module.exports = __webpack_public_path__ + "6697ed4ec30c1126be66b68e7739c272.pdf";